import { useActor } from '@xstate/react';
import React from 'react';
import SoloOnboardingContext from '../context';
import { EVENTS } from '../state-machine';
import {
  Header,
  CenteredContainer,
  PillButton,
  ProgressBar,
  ReadableContainer,
  ButtonContainer,
} from './common';
import styled from 'styled-components';
import { GOALS } from '../config';
import { LabelUppercase } from '../../elements/Text';
import * as Analytics from '../../../analytics';

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
`;

export default function AskGoal() {
  const onboardingService = React.useContext(SoloOnboardingContext);
  const [state, send] = useActor(onboardingService.service);

  Analytics.useTrackViewOnMount(
    Analytics.EVENTS.PROSUMER.ONBOARDING.VIEW_ASK_GOAL,
    state.context
  );

  return (
    <ReadableContainer>
      <CenteredContainer>
        <ProgressBar currentStep={1} />
        <LabelUppercase>Step 1</LabelUppercase>
        <Header>{GOALS.question}</Header>
        <ButtonContainer>
          <ButtonsWrapper>
            {Object.entries(GOALS.options).map(([key, { value, label }]) => (
              <PillButton
                key={key}
                label={label}
                isSelected={state.context.goal === value}
                onClick={() => {
                  send({
                    type: EVENTS.SELECT_GOAL,
                    goal: value,
                  });
                  send({
                    type: EVENTS.CONTINUE_ASK_GOAL,
                  });
                }}
              />
            ))}
          </ButtonsWrapper>
        </ButtonContainer>
      </CenteredContainer>
    </ReadableContainer>
  );
}
